














import Message from '@/types/Message.interface'
import Vue from 'vue'
export default Vue.extend({
    props: {
        smsMessage: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            error: {
                flag: false,
                text: 'edit this message to save'
            }
        }
    },
    computed: {
        operator(): boolean {
            //  Grab our current role
            const role = this.$store.getters.userRole(this.$store.getters.user)

            //  Check if this role is an operator
            return window.getProps(role, ['name']) === 'Operator'
        }
    },
    methods: {
        async saveMessage(msg: Message): Promise<boolean> {
            // If the message was not edited, emit an error and return
            if (!this.isEdited(msg)) {
                return (this.error.flag = true)
            }

            // Disable the error flag
            this.error.flag = false

            // Update the message
            this.smsMessage.text = msg.text
            this.smsMessage.media = msg.media

            // Send the request
            const resp = await this.$store.dispatch('messagesPut', this.smsMessage)

            // If response was successful, close the dialog
            if (resp) return this.$store.dispatch('dialogClose', 'APP')
        },
        isEdited(msg: Message): boolean {
            return (
                msg.text != this.smsMessage.text ||
                msg.media?.id != this.smsMessage.media?.id
            )
        }
    }
})
